import {
    ROUTEPATH_LOADING,
    ROUTEPATH_LOADED,
    ROUTEPATH_SEARCHED,
    ROUTEPATH_CREATED,
    ROUTEPATH_EDITED,
    ROUTEPATH_DELETED,
    ROUTEPATH_FAILED,
    LOGOUT,
} from '../types';

import {
    createPaginated,
    editPaginated,
    deletePaginated,
} from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    paths: null,
    searchResults: null,
    success: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ROUTEPATH_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case ROUTEPATH_LOADED:
            return {
                ...state,
                loading: false,
                success: false,
                paths: action.payload,
            };
        case ROUTEPATH_SEARCHED:
            return {
                ...state,
                loading: false,
                success: false,
                searchResults: action.payload,
            };
        case ROUTEPATH_CREATED:
            return {
                ...state,
                success: true,
                loading: false,
                paths: createPaginated(state.paths, action.payload),
            };
        case ROUTEPATH_EDITED:
            return {
                ...state,
                success: true,
                loading: false,
                paths: editPaginated(state.paths, action.payload),
            };
        case ROUTEPATH_DELETED:
            return {
                ...state,
                success: true,
                loading: false,
                paths: deletePaginated(state.paths, action.payload),
            };
        case ROUTEPATH_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                loading: false,
                paths: null,
                searchResults: null,
                success: false,
            };
        default:
            return state;
    }
}